import { render, staticRenderFns } from "./Testimonial1.vue?vue&type=template&id=61348611"
import script from "./Testimonial1.vue?vue&type=script&lang=js"
export * from "./Testimonial1.vue?vue&type=script&lang=js"
import style0 from "./Testimonial1.vue?vue&type=style&index=0&id=61348611&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports